import script from "./RtbFormIdentity.vue?vue&type=script&setup=true&lang=js"
export * from "./RtbFormIdentity.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__